import { reactive } from 'vue'

// Global reactive state to trigger feedback modal from anywhere (e.g., Sentry beforeSend).
// Using reactive() instead of a plain object with refs ensures Vue's dependency tracking
// works correctly when properties are accessed inside component templates.
export const feedbackState = reactive({
  isOpen: false,
  startMinimized: false,
  errorContext: null as string | null,

  // Open the feedback modal (optionally minimized for crash reports)
  open(options?: { minimized?: boolean; errorContext?: string }) {
    this.startMinimized = options?.minimized ?? false
    this.errorContext = options?.errorContext ?? null
    this.isOpen = true
  },

  // Close the feedback modal
  close() {
    this.isOpen = false
    this.startMinimized = false
    this.errorContext = null
  },
})
